import type { DateRangeToken } from "./types";

/**
 * Turns a date token into a real range.
 *
 * Done here rather than in the model: it does not reliably know today's date,
 * and asking it to subtract seven days from a date it guessed is a good way to
 * silently search the wrong week.
 *
 * `now` is injectable so the conversion can be tested without freezing time.
 */
export function dateRangeFor(
  token: DateRangeToken,
  now: Date = new Date()
): { startDate?: string; endDate?: string } | undefined {
  if (token === "any") return undefined;

  const days = { today: 0, last_7_days: 7, last_30_days: 30, last_90_days: 90 }[
    token
  ];
  const start = new Date(now);
  start.setDate(start.getDate() - days);
  start.setHours(0, 0, 0, 0);

  // End is left open: "this week" means since Monday, not up to some cutoff,
  // and a hard end date would hide anything published while they were typing.
  return { startDate: start.toISOString() };
}
